import { iconPaths, type IconName } from "./iconPaths";

/** Ícone SVG local (sem fonte de ícones, sem requisição). */
export function Icon({ name, className = "", flipped }: { name: IconName; className?: string; flipped?: boolean }) {
  return (
    <svg
      className={`ui-icon ${flipped ? "flipped" : ""} ${className}`}
      data-icon={name}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      // Caminhos estáticos do próprio bundle (iconPaths.ts), nunca dado de usuário.
      dangerouslySetInnerHTML={{ __html: iconPaths[name] }}
    />
  );
}
